(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("survey-core"), require("survey-creator-core"));
	else if(typeof define === 'function' && define.amd)
		define("[dashedname]", ["survey-core", "survey-creator-core"], factory);
	else if(typeof exports === 'object')
		exports["[dashedname]"] = factory(require("survey-core"), require("survey-creator-core"));
	else
		root["SurveyCreatorUIPresetEditorCore"] = factory(root["Survey"], root["SurveyCreatorCore"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__156__, __WEBPACK_EXTERNAL_MODULE__982__) => {
return 